import { WithInvalidFieldsContext } from 'components/common-form/contexts/WithInvalidFieldsContext';
import { SecondaryMarketToolbar } from 'components/secondaryMarket/shared/toolbar/SecondaryMarketToolbar';
import type { SecondaryMarketFormProps } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/shared/Form.connect';
import type { SecondaryMarketKeys, SecondaryMarketKeysPrefix } from 'locales/secondaryMarketKeys';
import { FC } from 'react';
import type { Form } from 'state/secondaryMarket/shared/form/form.model';

import { ModifiedFieldsContext } from '../shared';
import { SecondaryFormTemplate } from '../shared/components/SecondaryFormTemplate';
import { TabFatalError } from '../shared/TabFatalError';
import { LiveFormContentSkeleton } from './liveFormContent.skeleton';

export const LiveForm: FC<SecondaryMarketFormProps> = ({
  hasFatalError,
  isLoading,
  bcsProductKey,
  productName,
  traderLabel,
  modifiedFields,
  canResetForm,
  errors,
  sidePanel,
  workspaceType,
  children,
  onResetForm,
  errorKind,
  errorMessage,
  onRetryProductFetch,
}) => {
  if (hasFatalError) {
    if (errorKind === 'Timeout') {
      return <TabFatalError onRetry={onRetryProductFetch} detailsKey="generic.timeout.message" />;
    } else if (errorKind === 'BadRequest') {
      return <TabFatalError details={errorMessage} />;
    }
    return <TabFatalError />;
  }

  return (
    <ModifiedFieldsContext.Provider value={modifiedFields}>
      <WithInvalidFieldsContext<Form, SecondaryMarketKeys, SecondaryMarketKeysPrefix> validationErrors={errors}>
        <SecondaryFormTemplate
          toolbar={
            <SecondaryMarketToolbar
              isLoading={isLoading}
              onResetForm={onResetForm}
              bcsProductKey={bcsProductKey}
              productName={productName}
              traderLabel={traderLabel}
              canResetForm={canResetForm}
              type="live"
            />
          }
          sidePanel={sidePanel}
          bigSidePanel
        >
          {isLoading ? <LiveFormContentSkeleton workspaceType={workspaceType} /> : children}
        </SecondaryFormTemplate>
      </WithInvalidFieldsContext>
    </ModifiedFieldsContext.Provider>
  );
};

LiveForm.displayName = 'LiveForm';
